
export type PartialExcept<T, K extends keyof T> = Partial<Omit<T, K>> & Pick<T, K>;

export class Misc {
  static captilizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static extractOrgUid(url: string): string | null {
    const match = url.match(/orgs\/([^/]+)/g);
    if (!match || match.length === 0) return null;
    const last = match[match.length - 1];
    const uid = last.split('/')[1];
    return uid || null;
  }

  static getErrorMessage(errorObject: unknown): string {
    if (errorObject instanceof Error) {
      return errorObject.message;
    }
    return "Unknown Error";
  }
}
